@if (cardConfig) {
  <bw-action-card-legacy
    [cardConfig]="cardConfig"
    (ctaClicked)="onCtaClicked()"
  ></bw-action-card-legacy>
}
